import type { IToastAction } from '../IToastAction'
import type { ShowToastOptions } from '@ztechapps/common.hook'
import type { TypeOptions } from 'react-toastify'
import { toast } from 'react-toastify'
import { ToastActionBase } from '../ToastActionBase'

export class ReactToastifyToastAction extends ToastActionBase implements IToastAction {
  override showToast(options?: ShowToastOptions) {
    let mappedType: TypeOptions
    switch (options.type) {
      case 'danger':
        mappedType = 'error'
        break
      case 'warning':
        mappedType = 'warning'
        break
      case 'info':
        mappedType = 'info'
        break
      case 'success':
        mappedType = 'success'
        break
      case 'default':
        mappedType = 'default'
        break
      default:
        mappedType = 'success'
    }

    toast(options.message, { type: mappedType })
    super.showToast(options)
  }
}
